import React from "react";
import { Link } from "react-router-dom";
import LegalPage, { LegalSection } from "./LegalPage";

export default function TermsPage() {
  return (
    <LegalPage title="Terms & Conditions" updated="October 5, 2026">
      <p>
        These terms apply to text messages sent by Progressive Venture LLC for
        Grace (Gracewell), an AI companion device for older adults.
      </p>

      <LegalSection heading="SMS Terms">
        <ul>
          <li>
            <strong>Program:</strong> Grace video-call invitations. When the
            user of a Grace device asks to video call a family member, that
            family member receives one text message with a link to join the
            call.
          </li>
          <li>
            <strong>Who receives messages:</strong> only family members who
            gave their mobile number and agreed to receive these invitations.
          </li>
          <li>
            <strong>Message frequency:</strong> varies, usually a few messages
            a month. Messages are sent only when the Grace device's user asks
            for a call.
          </li>
          <li>
            <strong>Message and data rates may apply.</strong>
          </li>
          <li>
            <strong>Opt out:</strong> reply STOP at any time. You will receive
            one confirmation message and no further texts.
          </li>
          <li>
            <strong>Help:</strong> reply HELP, or email{" "}
            <a href="mailto:info@skew.digital">info@skew.digital</a>.
          </li>
          <li>Carriers are not liable for delayed or undelivered messages.</li>
          <li>
            <strong>Privacy:</strong> see our{" "}
            <Link to="/gracewell/privacypolicy">Privacy Policy</Link>.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="General">
        <p>
          The messaging service is provided by Progressive Venture LLC. We may
          change these terms. Changes are posted on this page with a new "Last
          updated" date.
        </p>
        <p>
          Contact: Progressive Venture LLC ·{" "}
          <a href="mailto:info@skew.digital">info@skew.digital</a>
        </p>
      </LegalSection>
    </LegalPage>
  );
}
